export const TEST_ID = 'verifyEmailPage';
